import * as React from 'react';
import { LoadOptions, Options, ComplexValue } from 'ui';

/**
 * Includes the primary key as iterator id in calls to load options.
 */
export function withPrimaryKeyAsOptionIteratorId<P extends Partial<Options<any> & { primaryKey: ComplexValue<number> }>>(
  WrappedComponent: React.ComponentClass<P>
): React.ComponentClass<P> {
  return class extends React.Component<P> {
    private onLoadOptions = (options: LoadOptions): void => {
      if (this.props.onLoadOptions) {
        const { primaryKey } = this.props;
        this.props.onLoadOptions({ iteratorId: primaryKey && primaryKey.value, ...options });
      }
    };

    public render() {
      return <WrappedComponent {...this.props} {...{onLoadOptions: this.onLoadOptions}} />;
    }
  };
}
